export const PRODUCT_FIELDS = `
id
ext_id
type
variantsIds
price
name
variants
attributes
attributesAdditions
images
merchant {
    id
    quota
    limitPerOrder
    sellOutOfStock
    price
    data
    productAttributes
    shippingType
    timeToShip
    delayedTimeToShip
    reviewCount
    rating
    url
    tierPrice
}
crosssells
upsells
upgrades
categories
fees {
    id
    type
    name
    value
    is_percent
    per_product
}
excludedPaymentTypes
isNotBuyable
reviews
reviewCount
rating
buyOptions
public_attributes
questions {
    date
    text
    email
    answers {
        date
        text
        public_name
        avatar
    }
}
`;